<script setup lang="ts">
const { isAuthenticated } = useAuth()
const { trialDaysRemaining, isDone } = useOrgMetadata()

const isTrialExpired = computed(() => {
  if (!isAuthenticated.value || !isDone.value) return false
  return trialDaysRemaining.value !== undefined && trialDaysRemaining.value <= 0
})
</script>

<template>
  <UModal :model-value="isTrialExpired" prevent-close>
    <ModalContentWrapper title="Your trial has expired" hide-close-button>
      <div class="py-4 text-center">
        <UIcon name="light:clock" class="mx-auto mb-4 size-16 text-red-500 dark:text-red-400" />
        <p class="text-gray-600 dark:text-gray-400">
          Your free trial period has ended. Please upgrade your plan to continue using Skills.
        </p>
      </div>

      <template #footer>
        <!-- TODO: Use an actial link/route once the page exists -->
        <UButton to="https://app.skills.new/pricing" target="_blank" size="lg"> View pricing plans </UButton>
      </template>
    </ModalContentWrapper>
  </UModal>
</template>
